module.exports = __webpack_public_path__ + "img/Autofaktura6.928dedc1.png";